import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import styles from "./promo-banner.css";

interface PromoPicture {
    mobile: string | null;
    tablet: string | null;
    desktop: string | null;
    desktopXl: string | null;
    altText: string;
}

function PromoPicture({ mobile, tablet, desktop, desktopXl, altText }: PromoPicture): JSX.Element {
    return (
        <picture className={styles.picture}>
            {/* XL Desktop */}
            {desktopXl && <source srcSet={desktopXl} media="(min-width: 1200px)" />}

            {/* Desktop */}
            {desktop && <source srcSet={desktop} media="(min-width: 768px)" />}

            {/* Tablet */}
            {tablet && <source srcSet={tablet} media="(min-width: 576px)" />}

            {/* Mobile */}
            {mobile && <source srcSet={mobile} media="(max-width: 575px)" />}

            {/* Fallback if picture element not supported */}
            <img className={styles.image} src={desktop || ""} alt={altText} />
        </picture>
    );
}

export interface PromoBannerProps {
    url: string;
    mobile: string | null;
    tablet: string | null;
    desktop: string | null;
    desktop_xl: string | null;
    alt_text: string;
    is_branch_link: boolean;
}

export function PromoBanner({
    url,
    mobile,
    tablet,
    desktop,
    desktop_xl: desktopXl,
    alt_text: altText,
    is_branch_link: isBranchLink,
}: PromoBannerProps): JSX.Element | null {
    if (mobile == null && tablet == null && desktop == null && desktopXl == null) {
        return null;
    }

    const promoPicture = (
        <PromoPicture
            mobile={mobile}
            tablet={tablet}
            desktop={desktop}
            desktopXl={desktopXl}
            altText={altText}
        />
    );

    return (
        <div className={styles.container}>
            {isBranchLink ? (
                <BranchLink title={""} branchLink={url} eventLabel={"homepage_promo"}>
                    {promoPicture}
                </BranchLink>
            ) : (
                <a href={url}>{promoPicture}</a>
            )}
        </div>
    );
}

export default PromoBanner;
